import React from "react";
import WebProject from "../../components/WebProject";
import web1 from "../../img/web1.png";
import web2 from "../../img/web2.png";
import web3 from "../../img/web3.png";

function WebProjects() {
  return (
    <section className="relative py-20 lg:py-40 max-w-screen-lg mx-auto">
      <h1 className="section-title">Web Projects</h1>
      <div className="grid lg:grid-cols-3 gap-10">
        <WebProject
          image={web1}
          title="DORSHS"
          description="is a Web-based school portal built using ReactJS and Firebase. The website serves three (3) types of users: students, teachers, and administrators. Online enrollment for students, login and logout for all users, file uploads, admin verification, submit student grades, user management, and so on are some of the features. Firebase Firestore and React Context API are used to manage all data, while Firebase Authentication is used for all user authentication and Firebase Storage is used to save and store all uploaded files. Material UI and custom CSS were used to create the user interface, and React Router was used to handle page routing."
          tech={[
            "ReactJS",
            "React Context API",
            "React Router",
            "Firebase",
            "Material UI",
          ]}
          website="https://dorshs.com/"
        />
        <WebProject
          middle={true}
          image={web2}
          title="DAVAO MARKET"
          description="is a web-based e-commerce platform built with ReactJS and Firebase. The client, the store administrator, and the system administrator are the three (3) users of the website. Authentication, location-based restaurant filtering, product purchasing and selling, product and order supervision, user role-based page routing, admin management, and real-time data updates were among the features. Firebase Realtime Database and React Context API are used to handle data, while Firebase Functions are used to manage background data update. Ant Design and Material UI are used to design the user interface, and React Router is used to manage page routing."
          tech={[
            "ReactJS",
            "React Context API",
            "React Router",
            "Firebase",
            "AntD",
            "Material UI",
          ]}
          website="https://davaomarket.com/"
        />
        <WebProject
          image={web3}
          title="NUTR.IO"
          description="is a Web-based dietitian portal built using ReactJS and Firebase. This system is designed to help RNDs (Registered Nutritionist Dietitians) connect with their GDM patients (Gestational Diabetes Mellitus). Authentication (registration and login), viewing, interviewing, and assessing patients, and day-to-day engagement with the patient via online messaging are among the features. Updating patients data made efficient through real-time update feature of Firebase Firestore. Data is distributed to the frontend through React Context API, the user interface is created with Ant Design, and page routing is handled with React Router."
          tech={[
            "ReactJS",
            "React Context API",
            "React Router",
            "Firebase",
            "Ant Design",
          ]}
          website="https://nutrio-final.web.app"
        />
      </div>
      {/* <div className="absolute h-full w-full top-0 left-0 grid place-items-center"></div> */}
    </section>
  );
}

export default WebProjects;
